module.exports = __webpack_public_path__ + "static/Business-c819573045157862afd8ceb1d9b278dd.png";